(function ($, win) {

  //Cache reference to window and animation items
  var $animation_elements = $('.animation-element');
  var $window = $(window);

  //Resize to keep fullscreen 
  function videoBannerScreen() {
    var headerHeight = $('#mainHeader').height();
    $('#player').css('margin-top', - headerHeight);
  }

  //Youtube Configurations
  var player;
  window.onYouTubeIframeAPIReady = function() {
    videoBannerScreen();
    var vidID = $('.video-wrapper').data('video-id');
    player = new YT.Player('player', {
      videoId: vidID,
      playlist: vidID,
      playerVars: {
          autoplay: 1,
          loop: 1,
          mute: 1,
          controls: 0,
          showinfo: 0,
          vq: 'hd1080',
          rel: 0,
          },
    });
  }

  $( window ).resize(function() {
    videoBannerScreen();
  });

  function getNext(_subject) {
    if(_subject.next().length > 0) { return _subject.next(); }
    return getNext(_subject.parent());
  }

  function searchFor(_selector, _subject) {
    if(_subject.is(_selector)) {return _subject;}
    else {
        var found = null;
        _subject.children().each(function() {
            found = searchFor(_selector, $(this));
            if(found != null) {return false;}
        });
        return found;
    }
    return null; // will/should never get here
  }

  function nextInDOM(_selector, _subject) {
    var next = getNext(_subject);
    while(next.length !== 0) {
        var found = searchFor(_selector, next);
        if(found != null) {return found;}
        next = getNext(next);
    }
    return null;
  }


  function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);
  
    $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = (element_top_position + element_height);
  
      //check to see if this current container is within viewport
      if ((element_bottom_position >= window_top_position) &&
          (element_top_position <= window_bottom_position)) {
        $element.addClass('in-view');

        if ($element.hasClass('testimonial-wrapper')) {
          if($element.hasClass('in-view')) {
            setTimeout(function(){ 
              $('#home-testimonials-wrapper .bg-image').addClass('show');
            }, 200);
            setTimeout(function(){ 
              $('#home-testimonials-wrapper .fg-image').addClass('show');
            }, 800);
            setTimeout(function(){ 
              $('#home-testimonials-wrapper .carousel-wrapper .wrap').addClass('show');
            }, 1200);
          }
        }

        if ($element.hasClass('home-slide-item')) {
          if($element.hasClass('in-view')) {
            setTimeout(function(){ 
              $element.find('.slider-title').addClass('show');
            }, 500);
            setTimeout(function(){ 
              $element.find('.intro').addClass('show');
            }, 1000);
          }
        }

        if ($element.hasClass('video-wrapper')) {
            setTimeout(function(){ 
              $element.find('.title').addClass('show');
            }, 500);
            setTimeout(function(){ 
              $element.find('.intro').addClass('show');
            }, 1000);
        }
      
      } else {
        if (!$element.hasClass('testimonial-wrapper') && 
          !$element.hasClass('home-slide-item') && 
          !$element.hasClass('video-wrapper') && 
          !$element.hasClass('page-wrapper') && 
          !$element.hasClass('contentWrapper') && 
          !$element.hasClass('formWrapper')) {
            $element.removeClass('in-view');
        }
        
      }
    });
  }

  function setPaddings() {
    container_size = $('.container').width();
    screen_size = $(window).width();

    padding = (screen_size - container_size) / 2;

    $('#home-news-wrapper .left').css('padding-left',padding);
    $('#home-join-social .left').css('padding-left',padding);
    $('#home-join-social .right').css('padding-right',padding);
    $('#home-testimonials-wrapper .carousel-wrapper').css('padding-left',padding);
    
    $('#home-banner .owl-dots').css('left',padding);

    $('.flexible-block-section.quick_links .quick-box .content-wrapper:even').css('padding-left',padding);
    $('.flexible-block-section.quick_links .quick-box .content-wrapper:odd').css('padding-right',padding);
  }

  function setPagination() {
    if ($('.post-navigation').length > 0) {
      $('.post-navigation ul.page-numbers li a.prev')
        .parent('li')
        .addClass('prev-page');
      $('.post-navigation ul.page-numbers li a.next')
        .parent('li')
        .addClass('next-page');
      $('.post-navigation ul.page-numbers li a.prev').addClass('nav-button');
      $('.post-navigation ul.page-numbers li a.next').addClass('nav-button');
      if ($('.post-navigation ul.page-numbers li.prev-page').length === 0) {
        $('.post-navigation ul.page-numbers').prepend('<li class="prev-page off"><i class="icon-chevron-2"></i></li>');
      }
      if ($('.post-navigation ul.page-numbers li.next-page').length === 0) {
        $('.post-navigation ul.page-numbers').append('<li class="next-page off"><i class="icon-chevron-2"></i></li>');
      }

      $('.post-navigation ul.page-numbers').find('.current').parent('li').addClass('current-page');
    }
  }

  $(document).ready(function () {

    var timer;
    var key_pressed = false;

    setPaddings();

    $('.burger-btn').click(function(){
      $('#mainHeader').toggleClass('menu-open');
      $(this).toggleClass('opened');
      $('#responsive-menu-wrapper').slideToggle(150);
    });

    $('.collapse').on('show.bs.collapse', function () {
      $(this)
        .prev()
        .addClass('active-acc');
    });

    $('.collapse').on('hidden.bs.collapse', function () {
      $(this)
        .prev()
        .removeClass('active-acc');
    });

    $('#home-message-box #message-close').click(function(){
      $('#home-message-box').fadeOut();
    });

    if (!$('#home-banner').hasClass('video')) {
      $('#home-banner').on('changed.owl.carousel', function (e) {
        setPaddings();
        check_if_in_view();
      }).owlCarousel({
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        loop: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 11500,
        margin: 0,
        items: 1,
        slideBy: 1,
        smartSpeed: 1050,
        thumbs: false
      });
    } 

    $('#home-news-slider .slider-item > .inner').matchHeight( true );

    $('#home-news-slider').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      autoplay: true,
      autoplayTimeout: 6500,
      margin: 0,
      slideBy:1,
      smartSpeed: 1000,
      navContainer: '#home-news-navs',
      navText: [
        '<i class="icon-arrow"></i>', '<i class="icon-arrow"></i>'
      ],
      thumbs: false,
      responsive: {
        0: {
          items:1
        },
        992: {
          items:3,
          autoWidth:true,
        }
      }
    });

    $('#home-testimonials-slider').on('initialized.owl.carousel', function () {
      $.fn.matchHeight._update();
    }).owlCarousel({
      loop: true,
      nav: false,
      dots:true,
      autoplay: true,
      autoplayTimeout: 6500,
      margin: 0,
      items:1,
      smartSpeed: 1000,
    });


    $('.member-box').on('click',function(){
      var nextEmpty = $(this).nextAll('.empty-place.hidden-md-down').first();
      var nextEmpty2 = $(this).nextAll('.empty-place.only-tablet').first();
      var nextEmpty3 = $(this).nextAll('.empty-place.hidden-sm-up').first();

      nextEmpty.find('.member-content').remove();
      nextEmpty2.find('.member-content').remove();
      nextEmpty3.find('.member-content').remove();
      $('.team-members .empty-place').slideUp();

      $('.member-box').css('opacity',1);

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        nextEmpty.hide();
        nextEmpty2.hide();
        nextEmpty3.hide();
      } else {
        $(this).siblings().removeClass('active');
        $('.member-box').not(this).css('opacity',0.5);
        $(this).addClass('active');
        content1 = $(this).find('.member-content').clone();
        content2 = $(this).find('.member-content').clone();
        content3 = $(this).find('.member-content').clone();
        nextEmpty.append(content1);
        nextEmpty.slideDown('slow');
        nextEmpty2.append(content2);
        nextEmpty2.slideDown('slow');
        nextEmpty3.append(content3);
        nextEmpty3.slideDown('slow');

        nextEmpty.find('.member-content .close-win').on('click',function(){
          $('.member-box').removeClass('active');
          $('.member-box').css('opacity',1);
          $('.team-members .empty-place').slideUp();
        });

        nextEmpty2.find('.member-content .close-win').on('click',function(){
          $('.member-box').removeClass('active');
          $('.member-box').css('opacity',1);
          $('.team-members .empty-place').slideUp();
        });

        nextEmpty3.find('.member-content .close-win').on('click',function(){
          $('.member-box').removeClass('active');
          $('.member-box').css('opacity',1);
          $('.team-members .empty-place').slideUp();
        });
      }
    });

    $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper.first input').on('keyup', function(){
      var time = 250;
      
      if (key_pressed == false) {
        key_pressed = true;
        $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper').each(function(index){
          if (!$(this).hasClass('first')) {
            setTimeout(function(){
              $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper:eq('+index+')').addClass('show');
            }, (index+1)*time);
          }
        });
        $(this).focus();
      }
    })

    // $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper.first input').keypress(function() {
    //   var time = 250;
      
    //   if (key_pressed == false) {
    //     key_pressed = true;
    //     $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper').each(function(index){
    //       if (!$(this).hasClass('first')) {
    //         setTimeout(function(){
    //           $('#contact-wrapper .formWrapper .wpcf7 .input-wrapper:eq('+index+')').addClass('show');
    //         }, (index+1)*time);
    //       }
    //     });
    //     $(this).focus();
    //   }
    // });

    $('#responsive-menu-wrapper .primary-menu > li > .sub-menu').each(function(){
      parent = $(this).parent('li');
      $(this).insertAfter(parent);
      parent.append('<span class="toggle"></span>');
    });

    $('#responsive-menu-wrapper .primary-menu > li .toggle').click(function(){
      $(this).toggleClass('active');
      $(this).parent('li').toggleClass('active');
      $(this).parent('li').next().slideToggle();
    });
  });

  // Naloxone click and deliver service
  if ($('.page-template-template-click-and-deliver').length > 0) {
    $('#who-is-for').on('change', function() {
      const val = $('#who-is-for :selected').val();
      $('#who-is-for-other-details').addClass('d-none');

      if (val == 'Other' || val == 'Arall') {
        $('#who-is-for-other-details').removeClass('d-none');
      }
    });
    
    $('#is-first-kit').on('change', function() {
      const val = $('#is-first-kit :selected').val();
      $('#is-first-kit-other-details').addClass('d-none');
      $('#is-first-kit-repeat-details').addClass('d-none');
      $('#is-repeat-supply-overdose').addClass('d-none');

      if (val == 'No, it\'s a repeat supply - other' || val == 'Na, mae\'n ailgyflenwad - arall') {
        $('#is-first-kit-repeat-details').removeClass('d-none');
      } else if (val == 'No, it\'s a repeat supply due to previous kit being used for an overdose' || val == 'Na, mae\'n ailgyflenwad oherwydd bod cit blaenorol yn cael ei ddefnyddio ar gyfer gorddos') {
        $('#is-repeat-supply-overdose').removeClass('d-none');
      } else if (val == 'Other' || val == 'Arall') {
        $('#is-first-kit-other-details').removeClass('d-none');
      } 
    });
  }


  $(window).on('load', function () {
    setPaddings();
    setPagination();
    $('.initial-hidden').css('opacity', 1);
  });

  $(window).on('resize', function () {
    setPaddings();
  });

  $window.on('scroll resize', check_if_in_view);

  $window.trigger('scroll');

})(jQuery, window); // Fully reference jQuery after this point.